module.exports = __webpack_public_path__ + "img/carousel-item-1.c1609816.svg";